import { GovernanceIssuesContent } from '../Issues/Issues';
import { GovernanceAccessBoundary } from '../GovernanceAccessBoundary';
import { CustomPolicyHeader } from './CustomPolicyHeader';
import { CustomPolicyTabs } from './CustomPolicyTabs';

function CustomPolicyIssuesContent() {
  return (
    <GovernanceIssuesContent
      header={<CustomPolicyHeader />}
      navigation={<CustomPolicyTabs active='issues' />}
    />
  );
}

function CustomPolicyIssues() {
  return (
    <GovernanceAccessBoundary>
      <CustomPolicyIssuesContent />
    </GovernanceAccessBoundary>
  );
}

export default CustomPolicyIssues;
